//用于获取页面主要信息的数据的模块

//引入工具类
const queryString = require('../../../common/util.js').queryString

const
// 在给定的日期基础上加上若干天，并格式化成 '2017-10-01' 的字符串返回
    addDays = require('../../../common/util').addDays
const sortFnc = require('./initPage').invokeAPIs

//用于页面一开始加载的时候进行验价（包括酒店是否下线以及供应商价格是否已修改）
//（与用户填写完订单并确认之后调的接口是同一个，但是此次验价的参数是从地址栏中取出）
function isHotelOnline (callback) {
    let checkParams = {
        suppId: queryString('suppId'),
        infoId: queryString('infoId')
    }
    
    $.post('/ticketController/check.do', checkParams, function (data) {
        callback(data)
    })
}

// 获取订单页面的初始化信息
function getInitData (comfirmDay, params, callback) {
    let checkParams = {
        carType: params.carType,
        isRealName: params.isRealName,
        validDate: comfirmDay,
        ticketRangeId: params.ticketRangeId,
        stockId: params.stockId,
        formulaType: params.formulaType,
        paymentType: params.paymentType,
        priceType: params.priceType,
        ticketType: params.ticketType,
        suppName: params.suppName,
        suppId: params.suppId,
        itemId: params.itemId,
        infoId: params.infoId
    }
    $.post('/ticketController/orderFit.do', checkParams, function (data) {
        callback(data)
    })
}

//请求日历价格
function getCanlendarPrice (days, callback) {
    
    let params = {
        ticketRangeId: queryString('ticketRangeId'),
        // ticketRangeId   	: 0,
        priceType: queryString('priceType'),
        paymentType: queryString('paymentType'),
        itemId: queryString('itemId'),
        formulaType: queryString('formulaType'),
        startDateStr: addDays(days, 0, '-'),
        endDateStr: addDays(days, 30, '-'),
        ticketType: queryString('ticketType')
    }
    
    $.post('/ticketController/searcCalendarPrice.do', params, function (res) {
        callback(res)
    })
}

//请求预定说明

function getOrderDec (params, callback) {
    $.post('/ticketController/findTicketRemmind.do', params, function (res) {
        callback(res)
    })
}

//请求护照国籍信息
function getNationalMsg (key, callback) {
    $.post('/order/countrySuggest.do', {'key': key}, function (data) {
        callback(data)
    })
}

//验证酒店价格是否适合于某国际客户
function isProperMarket (countryId, callback) {
    $.get('/order/properMarket.do',
        {'suppId': queryString('supplierId'), 'countryId': countryId},
        function (data) {
            callback(data)
        })
}

//验价
function checkThePrice (params, callback) {
    var paramsSer = $.param(params)
    $.ajax({
        type: 'POST',
        url: '/ticketController/orderSave.do',
        data: params,
        dataType: 'json',
        success: callback
    })
}

//验价成功后，保存订单
function saveOrder (params, callback) {
    $.post('/order/saveOrder.do', params, function (data) {
        callback(data)
    })
}

/**
 * 加床、加早、加宽带的ajax公共函数
 * @param {*} cb 回调函数
 * @param {*} flag 1：加早；2：加床；3：加宽带
 */
function loadBBN (cb, flag) {
    var params = {
        startDate: queryString('startDate'),
        endDate: queryString('endDate'),
        infoId: queryString('staticInfoId'),
        suppId: queryString('supplierId'),
        roomtypeId: queryString('roomId'),
        roomNum: queryString('roomNum'),
        typeId: flag
    }
    
    $.post('/order/surchargeRoom.do', params, function (res) {
        cb(res)
    })
}

/**
 * 加床、加早、加宽带 的公共渲染函数
 * @param {*} context 这里指相关 DOM 的类名，将 htmlStr 渲染到指定 DOM
 * @param {*} htmlStr 用于渲染页面的 html 字符串
 * @param {*} option 其他操作，比如有回调函数，参数等...
 */
function renderBBN (context, htmlStr, option) {
    if (!$.orderInfo) {
        return setTimeout(function () {
            renderBBN(context, htmlStr, option)
        }, 100)
    }
    
    // 当 $.orderInfo 有值则说明已经完成了页面初步初始化，就可以在页面找到 '.network-msg-box' 元素
    $('.main').find(context)
        .show()
        .html(htmlStr)
    
    if (option) {
        option.cb(option.params)
    }
}

module.exports = {
    isHotelOnline: isHotelOnline,
    getCanlendarPrice: getCanlendarPrice,
    getInitData: getInitData,
    getOrderDec: getOrderDec,
    getNationalMsg: getNationalMsg,
    isProperMarket: isProperMarket,
    checkThePrice: checkThePrice,
    saveOrder: saveOrder,
    loadBBN: loadBBN,
    renderBBN: renderBBN
}



// WEBPACK FOOTER //
// ./src/js/ticketOrderConfirm/modules/sendRequest.js